import React, { useState, useEffect } from 'react';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar'; 
import Footer from '../Layout/Footer';
import { putAPI,postAPI, uploadImageAPI,get, deleteAPI } from '../../services/ApiService';
import { apiBaseURL } from "../../Common/Constant";
import {DateFunc} from '../../services/Date';
import { masterData } from '../../api/master-data';


function Data() {
    const [message, setMessage] = useState("");//for error handling
    const [histories, setHistoryList] = useState([]);//for error handling
    const [internetActivities, setInternetActivity] = useState([]);//for error handling
    const [financialQuarters, setFinancialQuarter] = useState([]);//for error handling

    const getInternetActivity = async() => {
        let data = {page: 1,recPerPage: 500, q: "",func:''}
        let res = await get('/internet-activity/type-list', data); 
        if(res.status === 1){
            if(res.payload.length > 0){
                const activitis = res.payload;//.filter(activity => activity.status === 1);
                setInternetActivity(activitis);
                // setInternetActivity(res.payload)
            }
        }
    };

     const getFinancialQuarter= async() => {
        let res = await masterData({'moduleName':'financial-quarter'});
        if(res.status === 1){
            if(res.payload.length > 0){
                // const slugs = res.payload.map(activity => activity.slug);
                setFinancialQuarter(res.payload);
                // setInternetActivity(res.payload)
            }
        }
    };
  
    
     const submitForm = async (e) => {
            e.preventDefault();
        
            // Retrieve the token from localStorage
            const _token = localStorage.getItem("token");
        
            if (!_token) {
                setMessage("Authentication token is missing. Please log in again.");
                return;
            }
        
            // Create FormData and append the file and dataType
            let formData = new FormData();
            formData.append('dataType', 'data');
            formData.append('file', e.target.file.files[0]);
            formData.append('financialQuarter', e.target.financialQuarter.value);
            formData.append('internetActivity', e.target.internetActivity.value);
        
            // Use XMLHttpRequest to upload the file and handle progress updates
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${apiBaseURL}/research/primary/kpi/upload/`, true);
            // xhr.timeout = 600000; // 5 minutes timeout (in milliseconds)
            // Set Authorization header
            xhr.setRequestHeader("Authorization", `Bearer ${_token}`);
        
            let msg = "";
            // Track upload progress
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    msg = `Uploading... ${percentComplete}% completed!`;
                    if(percentComplete === 100) {
                        msg += `<br>Processing file...`;
                    }
                    setMessage(msg);
                }
            };
        
           
            // Handle server-sent progress updates
            xhr.onreadystatechange = (msg) => {
                if (xhr.readyState === 3) { // ReadyState 3 means the response is being received
                    const responseText = xhr.responseText;
                    const updates = responseText.split('\n'); // Split the response into lines
        
                    updates.forEach((update) => {
                        if (update.trim().startsWith('data:')) {
                            try {
                                const progress = JSON.parse(update.trim().substring(5)); // Parse the JSON after 'data:'
                                console.log('Progress update:', progress);
        
                                // Display each step's message in real-time
                                setMessage(`Processing file...<br>Step: <b>${progress.sheetName}</b> - ${progress.message}`);
                            } catch (error) {
                                console.error('Error parsing progress update:', error);
                            }
                        }
                    });
                }
            };
        
            // Handle response after file upload
            xhr.onload = () => {
                if (xhr.status === 200) {
    
                    const responseText = xhr.responseText;
                    const update = responseText.split('\n')[0]; // Split the response into lines
        
                    //updates.forEach((update) => {
                        if (update.trim().startsWith('data:')) {
                            try {
                                const progress = JSON.parse(update.trim().substring(5)); // Parse the JSON after 'data:'
                                console.log('Progress update:', progress);
        
                                // Display each step's message in real-time
                                console.log('Progress update:', progress);
                                if(progress.step === 'error'){
                                    setMessage(msg+`<br><b>ERROR: </b>- ${progress.message}`);
                                }else{
                                    setMessage(msg+'<br>File Processing completed successfully!');
                                }
                            } catch (error) {
                                console.error('Error parsing progress update:', error);
                            }
                        }
                    // });
    
                    getList();
                } else {
                    setMessage('An error occurred during the upload.');
                }
            };
        
            xhr.onerror = () => {
                setMessage('An error occurred while uploading the file.');
            };
        
            // Send the request
            xhr.send(formData);
        };

    const getList = async() =>{
        //setMessage();
        
        let data = {};//{page: pageInfo.current_page?pageInfo.current_page:0,recPerPage: 50, q: '',typeSlug:'primary-study'}
        let res = await get('/research/primary/get-upload-history?dataType=data', data);        
            if(res.status === 1){
                setHistoryList(res.payload)
            }else{
            setHistoryList([]);
            }
    }

    useEffect(()=>{
        getInternetActivity();
        getFinancialQuarter();
        getList();
    },[])


    return (
        <>

            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">
                    {/* <div className='page-title p-4 pb-0'>
                        <h1 className='h5 m-0 text-uppercase'>Researche Database Access</h1>
                    </div> */}
                    <section className=''>
                        <div className='container'>
                            <div className='row g-3'>
                                
                                <div className='col-lg-12 col-md-12 col-sm-12'>
                                    <div className='form-theme included-label rounded-4 shadow' >
                                        {/* <h2 className='h5 bg-light border-bottom border-primary border-4  p-3'>Upload Excel file</h2> */}
                                        <form className="row p-3" onSubmit={submitForm}>  

                                            <div className="col-3 mb-3">
                                                <label htmlFor="financialQuarter">Financial Quarter</label>
                                                <select
                                                    className="form-control"
                                                    id="financialQuarter"
                                                    name="financialQuarter"
                                                    required
                                                >
                                                    <option value="">Select Financial Quarter</option>
                                                    {financialQuarters.map((quarter, idx) => (
                                                        <option key={idx} value={quarter.id}>
                                                            {quarter.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-2 mb-3">
                                                <label htmlFor="internetActivity">Internet Activity</label>
                                                <select
                                                    className="form-control"
                                                    id="internetActivity"
                                                    name="internetActivity"
                                                    required
                                                >
                                                    <option value="">Select Internet Activity</option>
                                                    {internetActivities.map((parent) => (
                                                        parent.children && parent.children.length && parent.status == 1 > 0 ? (
                                                            <React.Fragment key={parent.ID}>
                                                                <option value="" disabled style={{ fontWeight: 'bold', color: '#333' }}>
                                                                    {parent.name}
                                                                </option>
                                                                {parent.children.map((child) => (
                                                                    child.status == 1 ? (
                                                                    <option key={child.ID} value={child.ID} style={{ paddingLeft: '20px' }}>
                                                                        &nbsp;&nbsp;{child.name}
                                                                    </option>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                ))}
                                                            </React.Fragment>
                                                        ) : (
                                                            <></>
                                                        )
                                                    ))}
                                                </select>
                                            </div>
                                                                                                                          
                                            <div className="col-5 mb-3" style={{borderRight:"1px solid #ccc"}}>
                                                <label>Upload File</label>
                                                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                    <input className="form-control" type='file' name='file' required/>
                                                    &nbsp; <button type='submit' className='btn btn-primary'>Submit</button>
                                                </div>
                                                <div dangerouslySetInnerHTML={{ __html: message }}></div>
                                            </div>
                                            <div className='col-7  mt-4 bl-1'>
                                                {/* <ul>
                                                    <li>Upload file should be in .xlsx format</li>
                                                    <li>File can have multiple sheets with each sheet having MAX 3lakhs rows</li>
                                                    <li>File should contain only one header row with columns <br/>
                                                        <b>
                                                        </b>
                                                    </li>
                                                </ul> */}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <hr/>

                                <div className="row mt-2">
                                    <div className=" col-md-12 col-md-offset-3 ">
                                        <div className="card">

                                            {/* <!-- end card header --> */}

                                            <div className="card-body">
                                                <table className="table table-striped table-hover" style={{"text-align":"left"}}>
                                                    <thead>
                                                        <tr  style={{ color: "white", backgroundColor: "#3874ff" }}>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Upload Time</th>
                                                            <th scope="col">File</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Records</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Uploaded</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Status</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    {(histories && histories.length > 0 )? (
                                                    <tbody>
                                                        {histories?.map((list,index) => (
                                                            <tr key={list?.ID}>
                                                            <td>{index +1}</td>
                                                             
                                                            <td>{DateFunc.format(list.createdOn*1000,"dd mmm yyyy hh:mm ampm")}</td>
                                                            <td>
                                                                <a href={list.fileURL} target='_blank' ><svg xmlns="http://www.w3.org/2000/svg"  width="24" height="24" fill="currentColor" class="bi bi-filetype-xlsx" viewBox="0 0 16 16">
                                                                <path style={{color:"#3874ff"}} fill-rule="evenodd" d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"/>
                                                                </svg></a>
                                                            </td>
                                                            <td>{list.numberOfRecords}</td>
                                                            <td>{list.totalRecordsInserted}</td>
                                                            <td>
                                                                { list.numberOfRecords == list.totalRecordsInserted? 
                                                                    <span className='badge bg-success'>Success</span>
                                                                    :
                                                                    <span className='badge bg-danger'>Issue</span>

                                                                }
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                        ))}
                                                    </tbody>
                                                    ):(<>
                                                        <tr>
                                                            <td colSpan={9} id="dataMessage" style={{padding:"50px 0"}}>No data found</td>
                                                        </tr>
                                                    </>)}
                                                </table>
                                                {/* <Pagination pageInfo={pageInfo} changePage={changePage} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
                </div>
                </div>
            </div>
            <Footer />

        </>
    );
};

export default Data;
